import './Icon.scss'

import { GenIcon, IconTree } from 'react-icons'
import { getIcon } from './iconMappings'

interface IconProps {
  icon: string
  fill?: string
  className?: string
  style?: React.CSSProperties
  size?: string
}

// provided a default color picked from _variables.scss as mentioned in the designs
const Icon: React.FC<IconProps> = ({
  fill = '#0d85f4',
  icon,
  ...rest
}: IconProps): JSX.Element => {
  const IconValue = getIcon(icon)
  // Checks if icon is a custom json or from react-icons
  return typeof IconValue == 'function' ? (
    <IconValue fill={fill} color={fill} {...rest} />
  ) : (
    GenIcon(IconValue as IconTree)({ fill, color: fill, ...rest })
  )
}

export default Icon
